export default __webpack_public_path__ + "static/Inter-Medium-19051ee52164b5e6711943c7027c2de9.woff";